module.exports = __webpack_public_path__ + "images/stockavl.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/stockavl.png
// module id = jgDs
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13